import React from 'react'
import no from '../../../Assets/Images/Login/no.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { t } from 'i18next'
import { DUMMY_SKU_LITA } from 'Utils/constants'
import './confirmDummyProduct.css'

const ConfirmDummyProduct = ({ onContinue, onGoBack, dummyProductCount }) => {
  // Cerrar el modal limpia el estado pendiente igual que "Volver a editar"
  const closeModal = () => {
    onGoBack()
  }

  return (
    <>
      {/* Overlay de fondo oscuro */}
      <div className="modal-dummy-product-overlay" />
      <div
        className="modal-box-confirm-dummy-product"
        data-testid="modal-confirm-dummy-product">
        <div className="delete-confirm-container">
          <div className="confirmation-header">
            <button
              type="button"
              onClick={closeModal}
              className="close-modal"
              aria-label={t('DUMMY_LITA_T.CLOSE_MODAL_ARIA_LABEL')}>
              <img src={no} alt="close" />
            </button>
          </div>
          <div>
            <div className="confirmation-message">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                size={'4x'}
                style={{ color: 'var(--error-color)' }}
              />
              <p className="confirmation-text-delete mt-4">
                {t('DUMMY_LITA_T.PENDING_PRODUCTS_WARNING', {
                  count: dummyProductCount,
                })}
                <br />
                {t('DUMMY_LITA_T.PENDING_PRODUCTS_DETAIL', {
                  sku: DUMMY_SKU_LITA,
                })}
              </p>
            </div>
            <div className="modal-buttons">
              <button
                type="button"
                data-testid="btn-go-back-edit"
                onClick={onGoBack}
                className="btn modal-si">
                {t('DUMMY_LITA_T.GO_BACK_TO_EDIT')}
              </button>
              <button
                type="button"
                data-testid="btn-continue-save"
                onClick={onContinue}
                className="btn modal-no">
                {t('DUMMY_LITA_T.CONTINUE')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmDummyProduct
